import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 15px;
    
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 
                 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
    line-height: 1.4;
    color: ${props => props.theme.colors.text.primary};
    background-color: ${props => props.theme.colors.background.primary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
    outline: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    color: ${props => props.theme.colors.text.secondary};
  }

  .error {
    color: ${props => props.theme.colors.error};
    padding: 0.5rem;
    margin: 0.5rem 0;
    border-radius: 4px;
    background-color: ${props => props.theme.colors.error}08;
    border: 1px solid ${props => props.theme.colors.error}20;
  }

  .success {
    color: ${props => props.theme.colors.success};
    padding: 0.5rem;
    margin: 0.5rem 0;
    border-radius: 4px;
    background-color: ${props => props.theme.colors.success}08;
    border: 1px solid ${props => props.theme.colors.success}20;
  }
`;

export default GlobalStyles;